import { convertMDtoHTML } from "./index";
import "./static/styles/style.css";
import 'katex/dist/katex.min.css';
import example from 'raw-loader!./content/articles/how-to-write-text.md';
function getTemplate(articleHtml) {
    const currentTheme = localStorage.getItem('theme') || 'light';
    const currentIcon = currentTheme === 'dark' ? '🌙' : '☀️';
    console.log('currentTheme:', currentTheme);
    return `
    <div class="w-full border-b border-gray-300 dark:border-gray-700">
        <div class="container mx-auto px-4">            
            <nav class="flex items-center justify-start gap-4 py-4 border-b border-gray-200 dark:border-gray-800">                
                <div class="font-bold text-lg">Demo "markdown-ts-compiler" v.0.11.0</div>                                
                <button id="theme-toggle" class="p-2 rounded-full hover:bg-gray-100 dark:hover:bg-gray-800 transition-colors duration-200 focus:outline-none" style="font-size: 1.5rem; cursor: pointer; line-height: 1;">
                    ${currentIcon}
                </button>
            </nav>
        </div>        
        <div class="container mx-auto px-4 mt-6 pb-12">
            ${articleHtml}
        </div>
    </div>`;
}
async function initApp() {
    const contentContainer = document.getElementById('content');
    if (!contentContainer)
        return;
    try {
        const savedTheme = localStorage.getItem('theme') || 'light';
        applyThemeClass(savedTheme);
        const articleHtml = await convertMDtoHTML(example);
        contentContainer.innerHTML = getTemplate(articleHtml);
        setupThemeToggle();
    }
    catch (error) {
        console.error("Error initializing the app:", error);
    }
}
function setupThemeToggle() {
    const themeToggleBtn = document.getElementById('theme-toggle');
    themeToggleBtn?.addEventListener('click', () => {
        const newTheme = document.documentElement.classList.contains('dark') ? 'light' : 'dark';
        applyThemeClass(newTheme);
        localStorage.setItem('theme', newTheme);
        if (themeToggleBtn) {
            themeToggleBtn.innerText = newTheme === 'dark' ? '🌙' : '☀️';
        }
    });
}
function applyThemeClass(theme) {
    if (theme === 'dark') {
        document.documentElement.classList.add('dark');
        document.documentElement.classList.remove('light');
    }
    else {
        document.documentElement.classList.add('light');
        document.documentElement.classList.remove('dark');
    }
}
initApp();
